import axios from 'axios'

import { getToken } from './auth'

const api = axios.create({
  baseURL: process.env.REACT_APP_KITNET_BASE_URL
})

api.interceptors.request.use(async config => {
  const token = getToken()
  config.headers.version = `legacy`
  config.withCredentials = true
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default api
